import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios'
import Input from './UI/Input/Input'
import { define, tokenExpiredMsg, expNotifyDuration } from '../data/globals'
import MyEditor from './UI/MyEditor/MyEditor';
import { useNotify } from '../hooks/useNotify';


const CatFormAdd = (props) => {
    const newCatStore = useSelector(state => state.newCat)
    const dispath = useDispatch()
    const [isFilled1, setIsFilled1] = useState(false)
    const [isFilled2, setIsFilled2] = useState(false)
    const { pushNotify } = useNotify()


    function inputName(event) {
        dispath({ type: 'SetNewCatTitle', name: event.target.value })
        // сняте подсветки, если поле заполнено
        if(event.target.value.length > 0) setIsFilled1(false);
        else setIsFilled1(true)
    }
    // // Для простого инпута:
    // function inputDescr(event) {
    //     dispath({ type: 'SetNewCatDescr', description: event.target.value })
    //     // сняте подсветки, если поле заполнено
    //     if(event.target.value.length > 0) setIsFilled2(false);
    //     else setIsFilled2(true)
    //     // if(this.$store.state.newCat.description.length !== 0) this.isFilled2 = false; else this.isFilled2 = true
    // }
    // Для tinyMCE редактора (функция 1):
    function inputDescrEditorChange(editorText) {
        dispath({ type: 'SetNewCatDescr', description: editorText })
    }
    // Для tinyMCE редактора (функция 2):
    function inputDescrEditorKeyUp(){
        // сняте подсветки, если поле заполнено
        if(newCatStore.description.length > 0) setIsFilled2(false);
        else setIsFilled2(true)
    }
    // В tinyMCE onEditorChange отрабатывает не совсем так, как onChange у стандартного поля input. Поэтому приходится использовать onKeyUp. И, соответственно, вместо одной функции, использовать 2 (inputDescrEditorChenge и inputDescrEditorKeyUp)

    function checkForm(e) {
        e.preventDefault()
        let pointsToGo = 2
        // подсветка пустых полей
        if(newCatStore.name.length === 0) { setIsFilled1(true); pointsToGo-- }
        if(newCatStore.description.length === 0) { setIsFilled2(true); pointsToGo-- }
        // Поля заполнены - создаем категорию
        (pointsToGo === 2) ? createCategory()
            : pushNotify("Заполните обязательные поля,<br>чтобы создать категорию", "notifyRed")
            // : props.pushNotify("Заполните обязательные поля,<br>чтобы создать категорию", "notifyRed")
    }
    // function createCategory() {
    async function createCategory() {

        try {
            const response = await axios({
                method: 'post',
                url: define.pathToAPI + '/categories/create.php',
                data: JSON.stringify({
                    id: newCatStore.id,
                    name: newCatStore.name,
                    description: newCatStore.description,
                    userToken: localStorage.getItem('AuthToken'),
                }),
                // headers: {
                //     "Content-type": "application/json; charset=UTF-8"
                // }
            })
            // проверка ответа от create.php
            switch(response.data.message){
                case 'Категория создана':
                    props.create()
                    setIsFilled1(false)
                    setIsFilled2(false)
                    break
                case 'Токен устарел!':
                    pushNotify(tokenExpiredMsg, "notifyWelcome", expNotifyDuration)
                    // props.pushNotify(tokenExpiredMsg, "notifyWelcome", expNotifyDuration)
                    // ########################################################
                    // При блокировке доступа, удалить картинки, которые не были сохранены в базе
                    // ########################################################
                    break
                case 'Токены не совпадают! Доступ запрещен':
                    pushNotify("Токены не совпадают! Alarm! Доступ запрещен", "notifyWelcome")
                    // props.pushNotify("Токены не совпадают! Alarm! Доступ запрещен", "notifyWelcome")
                    // ########################################################
                    // При блокировке доступа, удалить картинки, которые не были сохранены в базе
                    // ########################################################
                    break
                default:
                    console.log('Ошибка при создании категории.\nСервер отвечает (код 200). Но нет подтверждения от create.php, что категория добавлена в базу')
                    alert('Ошибка при создании категории (см. консоль)')
                    break
            } // switch

        } catch (e) {
            if(e === 'AxiosError: Request failed with status code 400') {
                console.log('Ошибка при создании категории.\nКод: 400 - Данные неполные\n(в create.php получены не все поля).')
                alert('Ошибка (код: 400) при создании категории (см.  консоль)')
            } else {
                console.log(e)
                alert('Ошибка при создании категории\n' + e)
            }
        }
    }// createCategory


    return (
        <div className={ isFilled2 ? 'alarm-on' : 'alarm-off' }>
            <h1>{ props.header }</h1>
            <form >
                Название:<br/>
                <Input
                    className={`form-input w540 ${(isFilled1) ? "notfilled" : ""}`}
                    value={ newCatStore.name }
                    onChange={ inputName }
                    placeholder=""
                />
                <div className="tooltip mb-10">
                { isFilled1 && <div className="tooltiptext ml-90 mt-4">Заполните название</div> }
                </div>

                Описание:<br/>
                <MyEditor
                    value={ newCatStore.description }
                    onEditorChange={ inputDescrEditorChange }
                    onKeyUp={ inputDescrEditorKeyUp }
                />
                <div className="tooltip mb-15">
                { isFilled2 && <div className="tooltiptext ml-90 mt-m20">Заполните описание</div> }
                </div>

                <button onClick={ checkForm } className='btn greenBtn'>Создать</button>
            </form><br/>

        </div>
    )
}

export default CatFormAdd;